import { Home } from "../components/home/home";
import { InstituteLogin } from "../components/login/instituteLogin";
import { InistitutionHome } from "../components/Inistitution/inistituteHome";
import { FacilitatorHome } from "../components/facilitator/FacilitatorHome";
import { ForgotPassword } from "../components/forgotPassword/forgotPassword";
import { SchoolFoundationProgram } from "../components/Inistitution/schoolFoundationProgram";
import { SchoolSharedFilesComponent } from "../components/Inistitution/schoolSharedFiles";
import { SchoolOlympiadExamComponent } from "../components/Inistitution/schoolOlympiadExam";
import { FacilitatorInstitutionsList } from "../components/facilitator/FacilitatorInstitutionsList";
import { FacilitatorAddSchool } from "../components/facilitator/facilitator-school/facilitatorAddSchool";
import { FacilitatorEditSchool } from "../components/facilitator/facilitator-school/facilitatorEditSchool";
import { FacilitatorFoundationPrograms } from "../components/facilitator/facilitatorFoundationPrograms";
import { FacilitatorOlympiadExamComponent } from "../components/facilitator/facilitatorOlympiadExam";
import { FacilitatorSchoolFilesComponent } from "../components/facilitator/facilitatorSharedFiles";
import { SchoolAbhyasaBharathi } from "../components/Inistitution/schoolAbhyasaBharathi";
import { FacilitatorAbhyasaBharathi } from "../components/facilitator/facilitatorAbhyasaBharathi";
import { SchoolVideoLessionFile } from "../components/Inistitution/schoolVideoLessionFiles";
import { FacilitatorVideoLessionFile } from "../components/facilitator/facilitatorVideoLessionFile";
import { AdminUsersList } from "../components/facilitator/admin-user/AdminUsersList";
import { SchoolCertifications } from "../components/Inistitution/school-certifications/schoolCertifications";
import { SchoolSMS } from "../components/facilitator/admin-sms/school-sms";
import { SendSMSComponent } from "../components/facilitator/admin-sms/send-sms";
import { AdminHelpDesk } from "../components/facilitator/adminHelpDesk";
import { AdminFaqs } from "../components/facilitator/adminFaqs";
import { SchoolHelpPage } from "../components/Inistitution/schoolHelpPage";
import { AdminExamPapers } from "../components/facilitator/adminExamPapers";
import { ExamPaperBuilder } from "../components/facilitator/examPaperBuilder";

export const publicRoutes = [
  { path: "/", element: Home },
  { path: "/home", element: Home },
  { path: "/User/Login", element: InstituteLogin },
  { path: "/User/ForgotPassword", element: ForgotPassword },
];

export const schoolRoutes = [
  { path: "/school/Home", element: InistitutionHome },
  { path: "/School/SharedFiles", element: SchoolSharedFilesComponent },
  { path: "/School/Certifications", element: SchoolCertifications },
  { path: "/school/Help", element: SchoolHelpPage },
];

export const facilitatorRoutes = [
  { path: "/Facilitator/Home", element: FacilitatorHome },
  { path: "/Schools/list", element: FacilitatorInstitutionsList },
  { path: "/Schools/Add", element: FacilitatorAddSchool },
  { path: "/Schools/Edit/:schoolId", element: FacilitatorEditSchool },
  { path: "/Facilitator/SharedFiles/:schoolId?", element: FacilitatorSchoolFilesComponent },

  // Admin routes
  { path: "/Facilitator/AdminUsers", element: AdminUsersList },
  { path: "/Facilator/SendSMS", element: SendSMSComponent },
  { path: '/Facilitator/HelpDesk', element: AdminHelpDesk },
  { path: '/Facilitator/Faqs', element: AdminFaqs },
  { path: '/Facilitator/ExamPapers', element: AdminExamPapers },
  { path: '/Facilitator/ExamPaper/:id', element: ExamPaperBuilder },
];

/** Routes shared between school and admin — same URL, different component per user type */
export const sharedRoutes = [
  { path: "/FoundationProgram/:programName/:className", schoolElement: SchoolFoundationProgram, facilitatorElement: FacilitatorFoundationPrograms },
  { path: "/OlympiadExam/:examName", schoolElement: SchoolOlympiadExamComponent, facilitatorElement: FacilitatorOlympiadExamComponent },
  { path: "/magzine/abhyasabharathi", schoolElement: SchoolAbhyasaBharathi, facilitatorElement: FacilitatorAbhyasaBharathi },
  { path: "/Schools/VideoLessionFiles/:filterName", schoolElement: SchoolVideoLessionFile, facilitatorElement: FacilitatorVideoLessionFile },
];